import { Link, useLocation } from '@remix-run/react'
import { useOptionalUser } from '#app/utils/user.ts'
import { Logo } from './logo.tsx'

const LINKS = [
	{ to: '/calculator', label: 'Dosing calculator' },
	{ to: '/galleries', label: 'Community galleries' },
	{ to: '/pricing', label: 'Plans' },
	{ to: '/about', label: 'About' },
	{ to: '/support', label: 'Support' },
	{ to: '/privacy', label: 'Privacy' },
]

export const MarketingFooter = () => {
	const location = useLocation()
	const user = useOptionalUser()
	if (location.pathname.includes('dashboard')) return null

	return (
		<footer className="border-t border-slate-400/15 bg-[#020617] py-10 text-sm text-slate-400">
			<div className="mx-auto flex w-full max-w-[1160px] flex-wrap items-center justify-between gap-6 px-6">
				<Logo size="md" />
				<ul className="flex flex-wrap gap-x-5 gap-y-2">
					{LINKS.map(link => (
						<li key={link.to}>
							<Link
								to={link.to}
								className="rounded-sm hover:text-white focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-cyan-300"
							>
								{link.label}
							</Link>
						</li>
					))}
					<li>
						<Link
							to={user ? '/dashboard' : '/login'}
							className="rounded-sm hover:text-white focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-cyan-300"
						>
							{user ? 'Dashboard' : 'Sign in'}
						</Link>
					</li>
				</ul>
				<p>© 2024–{new Date().getFullYear()} ReefChronicles. All rights reserved.</p>
			</div>
		</footer>
	)
}
